import React, { useState } from "react";
import { useSelector } from "react-redux";
import "./PaymentMethod.css";

const paymentMethods = [
  {
    id: "cod",
    title: "Pay On Delivery",
    options: [
      {
        id: "cash",
        name: "Cash On Delivery",
        image: "/images/cod.png",
        disabled: false,
      },
    ],
  },
  {
    id: "recommended",
    title: "Recommended",
    options: [
      {
        id: "gpay",
        name: "Google Pay UPI",
        image: "/images/gpay.png",
        disabled: true,
      },
      {
        id: "phonepe",
        name: "PhonePe UPI",
        image: "/images/phonepe.png",
        disabled: true,
      },
    ],
  },
  {
    id: "cards",
    title: "Cards",
    options: [
      {
        id: "card",
        name: "Add Credit / Debit Card",
        image: "/images/card.png",
        disabled: true,
      },
    ],
  },
  {
    id: "wallets",
    title: "Wallets",
    options: [
      {
        id: "amazon",
        name: "Amazon Pay",
        image: "/images/amazonpay.png",
        disabled: true,
      },
    ],
  },
];

function PaymentMethod() {
  const [selected, setSelected] = useState("cash");
  const cartItems = useSelector((state) => state.wines.cart);
const totalAmount = cartItems.reduce((total, cartItem) => {
  const price = Number(cartItem.item.selectedRate || 0);
  return total + cartItem.amount * price;
}, 0);
const handleContinue = async () => {
  const payload = {
    mobile: "9119664868",
    cart_items: [
      {
        site_id: "1",
        cat_id: "2",
        bm_id: "868",
        b_q: "2",
        b_p: "0",
        b_n: "0",
        amount: "2000",
      },
      {
        site_id: "1",
        cat_id: "2",
        bm_id: "867",
        b_q: "3",
        b_p: "0",
        b_n: "0",
        amount: "4000",
      },
      {
        site_id: "1",
        cat_id: "2",
        bm_id: "866",
        b_q: "1",
        b_p: "0",
        b_n: "0",
        amount: "1500",
      },
    ],
  };

  try {
    const response = await fetch(
      "https://gitstool.in/dscsc/shop_app/create_order.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await response.json();

    console.log("Create Order Response:", data);

    if (data.status === "success") {
      console.log("Razorpay Order ID:", data.razorpay_order_id);
      console.log("Key:", data.key);
      console.log("Amount:", data.amount);

      // Next step: Open Razorpay Checkout
    } else {
      alert(data.message);
    }
  } catch (err) {
    console.error(err);
  }
};
  return (
    <div className="payment-page">
  <div className="payment-container">
      {/* Header */}
      <div className="payment-header">
        
        <h2>Payment Method</h2>
      </div>

      {/* Payment List */}
      <div className="payment-body">
        {paymentMethods.map((section) => (
          <div key={section.id} className="payment-section">
            <h3>{section.title}</h3>

           {section.options.map((item) => (
  <label
    key={item.id} 
    className={`payment-card ${
      selected === item.id ? "active" : ""
    } ${item.disabled ? "disabled" : ""}`}
  >
    <div className="payment-left">
      <img src={item.image} alt={item.name} />
      <span>{item.name}</span>
    </div>

    <input
      type="radio"
      name="payment"
      checked={selected === item.id}
      disabled={item.disabled}
      onChange={() => !item.disabled && setSelected(item.id)}
    />
  </label>
))}
          </div>
        ))}
      </div>

      {/* Footer */}
<div className="payment-footer">
    <div className="payment-footer-box">

        <div className="payment-total">
            <span>Total Amount</span>
           <h2>₹{totalAmount.toFixed(2)}</h2>
        </div>

     <button className="payment-btn" onClick={handleContinue}>
  CONTINUE
</button>

    </div>
</div>
    </div></div>
    
  );
}

export default PaymentMethod;